import { BookOpen, LayoutGrid, ScrollText, Smartphone, Feather } from "lucide-react";

const BADGES = {
  novel: ["Book", BookOpen, "bg-slate-900/85 text-amber-100 border-amber-400/40"],
  comic: ["Comic", LayoutGrid, "bg-rose-950/85 text-rose-100 border-rose-400/50"],
  manga: ["Manga", ScrollText, "bg-fuchsia-950/85 text-fuchsia-100 border-fuchsia-400/50"],
  webtoon: ["Webtoon", Smartphone, "bg-sky-950/85 text-sky-100 border-sky-400/50"],
  poetry: ["Poetry", Feather, "bg-emerald-950/85 text-emerald-100 border-emerald-400/50"],
};

export const FormatBadge = ({ format, slug, overlay = false }) => {
  const [label, Icon, tone] = BADGES[format] || BADGES.novel;
  return (
    <span data-testid={`format-badge-${overlay ? "cover" : "inline"}-${slug}`}
      className={`inline-flex items-center gap-1 rounded-full border backdrop-blur-md px-2 py-0.5 text-[10px] sm:text-[11px] font-medium tracking-wide uppercase ${tone} ${overlay ? "absolute bottom-2 left-2 z-10 shadow-lg pointer-events-none" : ""}`}>
      <Icon size={11} />{label}
    </span>
  );
};
